import Header from '@/components/landingpage/Header';
import Hero from '@/components/landingpage/Hero';
import Features from '@/components/landingpage/Features';
import Footer from '@/components/landingpage/Footer';
import TrustSignals from '@/components/landingpage/TrustSignals';
import { Toaster } from 'sonner';
import '@/styles/landing-theme.css';

export function Landing() {
  return (
    <div className="landing-page min-h-screen bg-background text-foreground relative overflow-hidden">
      {/* Abstract background shapes */}
      <div className="fixed inset-0 pointer-events-none z-0 overflow-hidden">
        <div className="absolute -top-40 -left-40 w-[700px] h-[700px] rounded-full bg-[radial-gradient(circle,_rgba(15,185,177,0.12)_0%,_transparent_70%)] blur-3xl" />
        <div className="absolute -top-20 right-0 w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,_rgba(255,179,71,0.08)_0%,_transparent_70%)] blur-3xl" />
        <div className="absolute top-[40%] -right-32 w-[600px] h-[600px] rounded-full bg-[radial-gradient(circle,_rgba(15,185,177,0.07)_0%,_transparent_70%)] blur-3xl" />
        <div className="absolute bottom-0 left-[10%] w-[500px] h-[500px] rounded-full bg-[radial-gradient(circle,_rgba(255,179,71,0.06)_0%,_transparent_70%)] blur-3xl" />
      </div>
      <Header />
      <main>
        <Hero />
        <Features />
        <TrustSignals />
      </main>
      <Footer />
      {/* AppLayout's <Toaster> only mounts for signed-in users, so the demo
          form's error toast needs its own here. */}
      <Toaster richColors closeButton duration={5000} />
    </div>
  );
}
